import { Translatable } from "@icc/shared/helpers";
import { BaseCoverType } from "./cover";

/** Typ skrzynki */
export class BlindBoxType extends BaseCoverType {
    id: string | number;
    @Translatable({ model: 'BlindBoxesTypes' })
    name: string;
    description: string;
    type: 'blind_box';
    img: string;
    imgSides: string;
    /** Dostępność moskitier
     *
     * * `unavailable` - Moskitiery niedostępne
     * * `only_one_mosquito_screen` - Maksymalnie jedna moskitiera na skrzynkę
     * * `wo_restrictions` - Bez ograniczeń
     * * null - niedostępne
     *
     */
    mosquitoScreenAvailability:
        | 'unavailable'
        | 'only_one_mosquito_screen'
        | 'wo_restrictions'
        | null;
    /** Moskitiera spowoduje niemożliwość stworzenia zestawu wielu żaluzji w jednej skrzynce */
    onlyOneShutterDueMosquitoScreen: boolean;
    /** Odległość na rynnę górną [mm] */
    spaceToTopRailMM: number;
    /** Malowanie poszczególnych elementów
     *
     * * `joining_together` - Profile gięte i tłoczone malowane razem lub całość skrzynki malowana
     * * `bent_sheets_only` - Profile gięte malowane, profile tłoczone domyślnie niemalowane
     * * `embossed_profiles_only` - Profile skrzynki nie mają opcji malowania
     * * `nothing` - Malowana jest tylko klapa rewizyjna
     * * `veneer_indoor_outdoor` - Można okleinować osobno od wewnątrz i od zewnątrz
     *
    */
    paintedElements: 'joining_together'
        | 'bent_sheets_only'
        | 'nothing'
        | 'veneer_indoor_outdoor';
    /**
     * Możliwość włączenia malowania profili tłoczonych w konfiguratorze
     */
    paintedEmbossedProfiles: boolean;
    /** Kod do indeksów */
    indexNo: string;
    /** Kod do wydruków */
    printCode: string;
    /** Domyślne prowadzenie skrajne */
    defaultGuideOnEdge: number | null;
    /** Domyślne prowadzenie wewnętrzne - wspólna wysokość */
    defaultGuideBetween: number | null;
    /** Domyślne prowadzenie wewnętrzne - różne wysokości */
    defaultGuideBetweenDifferentHeights: number | null;
    /** Kolejność */
    order: number;

    spaceBundleMm: number;

    hasDeepenSurcharge?: boolean;

    mountAxisDistanceMm?: number;

    spaceSubguideMountedOverTopRailMm?: number;
}
